import { useTypedParams } from "react-router-typesafe-routes";

import { ApplicationDashboard as ApplicationDashboardComponent } from "@components/Dashboards";

import { routes } from "@pages/routes";

export const ApplicationDashboard = () => {
  const { applicationId, clientId } = useTypedParams(
    routes.portal.clients.client.applications.application.dashboard,
  );

  return (
    <ApplicationDashboardComponent
      applicationId={applicationId}
      clientId={clientId}
    />
  );
};
